<template>
  <div id="order-care-bar" class="chartheight" :style="{ width: '100%'}"></div>
</template>

<script>
export default {
  props: {
    level: null,
  },
  data() {
    return {};
  },
  mounted() {
    this.$nextTick(() => {
      this.drawOrderCareBar();
      window.addEventListener("resize", () => {
        this.myCharts.resize();
      });
    });
  },
  methods: {
    //绘制柱状图
    drawOrderCareBar() {
      let orderCareBarChartOne = this.$echarts.init(
        document.getElementById("order-care-bar"),
        "light"
      ); //初始化echats实例
      var dataReset = [
        { value: this.level.level1Count },
        { value: this.level.level2Count },
        { value: this.level.level3Count },
        { value: this.level.level4Count },
        { value: this.level.level5Count },
        // { value: this.level.unknownLevelCount },
      ];
      var datasetReset = [
        "一星会员",
        "二星会员",
        "三星会员",
        "四星会员",
        "五星会员",     
      ];
      orderCareBarChartOne.setOption({
        tooltip: {
          trigger: "item",
          formatter: "{b} : {c} 人",
        },
        xAxis: {
          type: "category",
          data: datasetReset,
          axisLabel: {
            interval: 0, rotate:45
          },
        },
        grid: {
          containLabel: true,
          left: 0,
          right: 10,
          bottom: 0,
        },
        yAxis: {
          type: "value",
          axisLabel: {
            show: true,
            textStyle: {
              color: "#666666",
            },
          },
           axisLine: {
            //y轴
            show: false,
          },
          axisTick: {
            //y轴刻度线
            show: false,
          },
          splitLine: {
            //网格线
            show: true,
            color: "#999",
          },
        },
        series: [
          {
            type: "bar",
            barWidth: 20, //柱图宽度
            legendHoverLink: true,
            itemStyle: {
              normal: {
                label: {
                  // show: true, //开启显示
                  // position: "top", //在上方显示
                  textStyle: {
                    //数值样式
                    color: "#666666",
                    fontSize: 14,
                  },
                },
                color: function(params) {
                  var colorList = [
                    "#4878FF",
                    "#4878FF",
                    "#4878FF",
                    "#4878FF",
                    "#4878FF",
                    "#4878FF",
                  ];
                  return colorList[params.dataIndex];
                },
              },
            },
            data: dataReset,
          },
        ],
      });
      window.onresize = function() {
        orderCareBarChartOne.resize();
      };
    },
  },
};
</script>

<style scoped lang="scss">
    .chartheight{
      height: 300px ;
            @media screen and (max-width: 1400px){
              margin-top: 10px;
          height: 250px;
        }
          @media screen and (max-width: 1340px){
            margin-top: 10px;
          height: 230px;
        }
}
  
</style>
